import { actionTypePrefix } from './constants';
export var ACTION_TYPE_INITIALIZE = "".concat(actionTypePrefix, "/INITIALIZE");
//# sourceMappingURL=actionTypes.js.map